<template>
  <div class="e-steps">
    <b-row>
      <b-col cols="12">
        <ul class="e-breadcrumb">
          <li v-for="(step, i) in steps" :key="i" class="e-breadcrumb__item" :class="{'e-breadcrumb--active': step.number < current, 'e-breadcrumb--current': step.number === current}">
            <span>{{ step.label }}</span>
          </li>
        </ul>
      </b-col>
    </b-row>

    <slot></slot>
  </div>
</template>

<script>
  function debounce(fn) {
    let waiting;
    return function() {
      if (waiting) return;
      waiting = true;
      const context = this,
        args = arguments;
      const later = function() {
        waiting = false;
        fn.apply(context, args);
      };
      this.$nextTick(later);
    };
  }

	export default {
		name: "e-steps",
    props: [
      'current',
    ],
    data() {
		  return {
		    stepsComponents: [],
      }
    },
    computed: {
      steps() {
		    return this.stepsComponents.map((c, i) => {
		      return {
		        label: c.label,
            number: i + 1
		      }
		    });
      }
    },
    watch: {
		  current: {
		    handler(val) {
		      this.updateChildProps(true);
          this.$emit('changeStep', val);
        },
        immediate: true,
      }
    },
    methods: {
      updateChildProps (isInit) {
        this.stepsComponents = this.$children;
        this.$children.forEach((child, index) => {
          child.stepNumber = index + 1;

          if (!(isInit && child.currentStatus)) {
            if (index == this.current) {
              if (this.status != 'error') {
                child.currentStatus = 'process';
              }
            } else if (index < this.current) {
              child.currentStatus = 'finish';
            } else {
              child.currentStatus = 'wait';
            }
          }
          if (child.currentStatus != 'error' && index != 0) {
            this.$children[index - 1].nextError = false;
          }

          child.isVisible = index + 1 === this.current;
        });
      },
      updateCurrent (isInit) {
        if (this.current < 0 || this.current >= this.$children.length ) {
          return;
        }

        // this.$children[this.current].isVisible = true;

        // if (isInit) {
        //   const current_status = this.$children[this.current].currentStatus;
        //   if (!current_status) {
        //     this.$children[this.current].currentStatus = this.status;
        //   }
        // } else {
        //   this.$children[this.current].currentStatus = this.status;
        // }
      },
      debouncedAppendRemove () {
        return debounce(function () {
          this.updateSteps();
        });
      },
      updateSteps () {
        this.updateChildProps(true);
        this.updateCurrent(true);
      }
    },
    mounted () {
      this.updateSteps();
      this.$on('append', this.debouncedAppendRemove());
      this.$on('remove', this.debouncedAppendRemove());
    },
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/steps/steps.vue